import { ChangePasswordDialogExpComponent } from './changepasswordexp-dialog/changepassword.dialog.component';
import { NgModule } from "@angular/core";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { RightSidebarComponent } from "./layout/right-sidebar/right-sidebar.component";
import { LocationStrategy, HashLocationStrategy, DatePipe } from "@angular/common";
import { DynamicScriptLoaderService } from "./services/dynamic-script-loader.service";
import { RightSidebarService } from './services/rightsidebar.service';
import { WINDOW_PROVIDERS } from "./services/window.service";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IntercomModule } from '@supy-io/ngx-intercom';

import { SigninComponent } from './authentication/signin/signin.component';
import { AppHttpInterceptor } from './interceptor/tokenInterceptor';
import { ToastrModule } from 'ngx-toastr';
import { PipesModule } from './pipes/pipes.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderInterceptor } from './interceptor/loaderinterceptor';
import { CommonComponent } from './common/common.component';
import { MyLoaderComponent } from './my-loader/my-loader.component';
import { FooterComponent } from './authentication/footer/footer.component';
import { QrScanDialogComponent } from './near-miss/questionnaire/qr-scan-dialog/qr-scan-dialog.component';
// import { AnalyticsModule } from '@angular/fire/analytics';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatSelectModule } from '@angular/material/select';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { CommonFileService } from './shared/services/common-file-service.service';
import { SharedModule } from './shared/shared.module';
import { MatDatetimepickerModule, MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { MatMomentDatetimeModule } from '@mat-datetimepicker/moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnvService } from './services/environment.service';

// const cookieConfig: NgcCookieConsentConfig = {
//   "cookie": {
//     "domain": "app.goaudits.com",
//     // "domain": "3.10.174.98",
//     // "domain": "18.133.204.151",
//     //  "domain": "qa.goaudits.com",

//   },
//   "position": "bottom-left",
//   "theme": "block",
//   "palette": {
//     "popup": {
//       "background": "#ffffff",
//       "text": "#000000",
//       "link": "#000000"
//     },
//     "button": {
//       "background": "#000000",
//       "text": "#ffffff",
//       "border": "transparent"
//     }
//   },
//   "type": "info",
//   "content": {
//     "message": "This website uses cookies to ensure you get the best experience on our website. Your usage of the site assumes acceptance of our Privacy/Cookie Policy",
//     "dismiss": "Got it!",
//     "deny": "Refuse cookies",
//     "link": "Learn more",
//     "href": "https://admin.goaudits.com/assets/GoAudits_Privacy_Policy.html",
//     "policy": "Cookie Policy"
//   }
// };
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    CommonComponent,
    RightSidebarComponent,
    ChangePasswordDialogExpComponent,
    MyLoaderComponent,
    FooterComponent,
    QrScanDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSidenavModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    PipesModule,
    FormsModule,
    MatDatetimepickerModule,
    MatMomentDatetimeModule,
    MatSnackBarModule,
    MatNativeDatetimeModule,
    AngularFireModule.initializeApp(new EnvService().firebaseConfig),
    AngularFireMessagingModule,
    // AnalyticsModule,
    ToastrModule.forRoot(),
    IntercomModule.forRoot({
      appId: 'pjk6ouyh', // from your Intercom config
      updateOnRouterChange: true // will automatically run `update` on router event changes. Default: `false`
    }),
    SharedModule,
    // NgcCookieConsentModule.forRoot(cookieConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatSelectModule],
  providers: [
    CommonComponent,
    SigninComponent,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    DynamicScriptLoaderService,
    RightSidebarService,
    WINDOW_PROVIDERS,
    DatePipe,
    CommonFileService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}